import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";

// Create axios instance with auth
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

export const draftsApi = {
  /**
   * SAVE DRAFT (Create or Update)
   * Endpoint: POST /api/posts/drafts (create)
   *           PUT /api/posts/drafts/:id (update)
   * Body: { postType, content, ... }
   */
  saveDraft: async (draftData, draftId = null) => {
    if (draftId) {
      return apiClient.put(`/posts/drafts/${draftId}`, draftData);
    }
    return apiClient.post("/posts/drafts", draftData);
  },

  /**
   * GET USER'S DRAFTS
   * Endpoint: GET /api/posts/drafts
   * Params: { limit, offset, includeScheduled }
   */
  getDrafts: async ({
    limit = 20,
    offset = 0,
    includeScheduled = true,
  } = {}) => {
    return apiClient.get("/posts/drafts", {
      params: { limit, offset, includeScheduled },
    });
  },

  /**
   * GET SINGLE DRAFT
   * Endpoint: GET /api/posts/drafts/:id
   */
  getDraft: async (draftId) => {
    return apiClient.get(`/posts/drafts/${draftId}`);
  },

  /**
   * DELETE DRAFT
   * Endpoint: DELETE /api/posts/drafts/:id
   */
  deleteDraft: async (draftId) => {
    return apiClient.delete(`/posts/drafts/${draftId}`);
  },

  /**
   * PUBLISH DRAFT
   * Endpoint: POST /api/posts/drafts/:id/publish
   */
  publishDraft: async (draftId) => {
    return apiClient.post(`/posts/drafts/${draftId}/publish`);
  },

  /**
   * SCHEDULE DRAFT
   * Endpoint: POST /api/posts/drafts/:id/schedule
   * Body: { scheduledFor }
   */
  scheduleDraft: async (draftId, scheduledFor) => {
    return apiClient.post(`/posts/drafts/${draftId}/schedule`, {
      scheduledFor,
    });
  },
};

export default draftsApi;
